/**
 * Resolve a backend-relative path (e.g. "/api/uploads/abc") to a full URL.
 * Absolute http(s) URLs are returned unchanged UNLESS they point at a known
 * legacy backend hostname — in that case we strip the host so the relative
 * `/api/uploads/<id>` path goes through the current REACT_APP_BACKEND_URL.
 *
 * Why: image URLs stored in MongoDB before the upload endpoint was switched
 * to relative URLs still carry the old preview/cluster hostname, which the
 * browser flags as Mixed Content on https://kolv.lv.
 */
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Hosts we know used to host KoLV API before the relative-URL migration.
// Any /api/uploads/<id> path under these is routed through the current backend.
const LEGACY_HOSTS = /^https?:\/\/(?:[a-z0-9-]+\.)*(?:emergentcf\.cloud|emergentagent\.com|emergent\.host)/i;

export function resolveAssetUrl(u) {
  if (!u) return u;
  if (typeof u !== 'string') return u;
  if (u.startsWith('data:') || u.startsWith('blob:')) return u;

  // Legacy absolute URL pointing at an old KoLV backend → rewrite to current.
  if (LEGACY_HOSTS.test(u)) {
    const path = u.replace(LEGACY_HOSTS, '');
    return `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
  }

  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith('/')) return `${API_BASE}${u}`;
  return u;
}

// A listing/menu-item's photos as an array (first = cover). Falls back to the
// legacy single `image_url` when no `images` array is present.
export const itemImages = (item) =>
  (item && Array.isArray(item.images) && item.images.length)
    ? item.images.filter(Boolean)
    : (item && item.image_url ? [item.image_url] : []);
